module.exports = __webpack_public_path__ + "img/08-Email.bf4da63e.svg";